import { render, staticRenderFns } from "./createPedidos.vue?vue&type=template&id=701a7a0c&scoped=true&"
import script from "./createPedidos.vue?vue&type=script&lang=js&"
export * from "./createPedidos.vue?vue&type=script&lang=js&"
import style0 from "./createPedidos.vue?vue&type=style&index=0&id=701a7a0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701a7a0c",
  null
  
)

export default component.exports